import type { SettlementRepository } from '../repository/SettlementRepository';
import type { SearchSettlementsRequest, SearchSettlementsResponse } from '../entity/SettlementTypes';

export class SearchSettlementsUseCase {
  constructor(private readonly repository: SettlementRepository) {}

  async execute(request: SearchSettlementsRequest): Promise<SearchSettlementsResponse> {
    if (!request.params || request.params.length === 0) {
      throw new Error('검색 파라미터가 필요합니다.');
    }
    return this.repository.searchSettlements(request);
  }
}

